(ns frontend.ux-overhaul.listing.fof-asset.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.fof-asset.event :as fof-asset-event]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "fof-asset-listing")

(defn- open-fof-asset!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/fof-asset})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/fof-asset
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :fof-asset
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-fof-asset
                                 :label    (loc/tr :fof-asset-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::fof-asset-event/create-fof-asset]}
                                {:id                  :bulk-edit-fof-assets
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::fof-asset-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-fof-assets
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::fof-asset-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-fof-assets
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::fof-asset-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-fof-assets-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::fof-asset-event/export-grid-with-persons {:listing-id listing-id}]}
                                (menu-actions/field-requirements-action {:entity-type :entity.type/fof-asset})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :fof-assets)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.fof-asset/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::fof-asset-event/create-fof-asset])
         :on-row-clicked           open-fof-asset!
         :on-card-clicked          open-fof-asset!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/fof-asset}]
       [menu-actions/field-requirements-modal]])}))
